// @ts-nocheck
import { Handle, Position } from '@xyflow/react';
import {
  PlayCircle,
  HelpCircle,
  Cloud,
  MessageSquare,
  Repeat,
  StopCircle,
  GitBranch,
  Users,
  CheckCircle2,
  Circle,
} from 'lucide-react';

const NODE_STYLES = {
  start:          { accent: '#059669', icon: PlayCircle,   label: 'START',     badge: 'green' },
  question:       { accent: '#eab308', icon: HelpCircle,   label: 'QUESTION',  badge: 'orange' },
  api_call:       { accent: '#3b82f6', icon: Cloud,        label: 'API CALL',  badge: 'blue' },
  api:            { accent: '#3b82f6', icon: Cloud,        label: 'API CALL',  badge: 'blue' },
  message:        { accent: '#06b6d4', icon: MessageSquare, label: 'MESSAGE',  badge: 'cyan' },
  followup:       { accent: '#6b7280', icon: Repeat,       label: 'FOLLOWUP',  badge: 'slate' },
  follow_up:      { accent: '#6b7280', icon: Repeat,       label: 'FOLLOWUP',  badge: 'slate' },
  human_handover: { accent: '#a855f7', icon: Users,        label: 'HANDOVER',  badge: 'purple' },
  condition:      { accent: '#f97316', icon: GitBranch,    label: 'CONDITION', badge: 'orange' },
  completion:     { accent: '#14b8a6', icon: CheckCircle2, label: 'COMPLETION', badge: 'green' },
  end:            { accent: '#ef4444', icon: StopCircle,   label: 'END',       badge: 'red' },
};
const NEUTRAL = { accent: '#94a3b8', icon: Circle, label: 'STEP', badge: 'slate' };

export function styleForNodeType(type) {
  return NODE_STYLES[String(type || '').toLowerCase()] || NEUTRAL;
}

export default function FlowChartNode({ data }) {
  const style = styleForNodeType(data.nodeType);
  const Icon = style.icon;

  return (
    <div className="ivrn" style={{ '--node-color': style.accent }}>

      <Handle
        type="target"
        position={Position.Left}
        style={{ background: style.accent }}
      />

      
      <span
        className="ivrn-icon"
        style={{ background: style.accent, color: '#fff' }}
      >
        <Icon size={22} strokeWidth={2} />
      </span>

     
      <Handle
        type="source"
        position={Position.Right}
        style={{ background: style.accent }}
      />

      
      <div className="ivrn-head">
        <span className="ivrn-title">{data.title}</span>
        <span className={`ivrn-badge ivrn-badge--${style.badge}`}>
          {style.label}
        </span>
      </div>

      <div className="ivrn-body">
        {data.subtitle ? (
          <span className="ivrn-val">{data.subtitle}</span>
        ) : (
          <span className="ivrn-hint">Click ⚙ to configure</span>
        )}
      </div>
    </div>
  );
}
